<template>
  <section id="shop-by-style-filter" role="region" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <h3 class="text-center">Shop by style</h3>
          <div class="shop-by-body negative">
            <div class="no-margin row">
              <div class="col-md-4 col-xs-6 dashed no-padding">
                <a
                  class="style-link body_type"
                  data-filter-type="body"
                  data-param="Sedan"
                   @click="toggleActive"
                  ><div class="cell-center">
                    <img
                      class="center-block img-responsive"
                      src="../../static/images/common-icons/shop-by-sedan.png"
                      alt="Sedans"/>
                    <small class="center-block text-center">Sedans</small>
                  </div>
                </a>
              </div>
              <div class="col-md-4 col-xs-6 dashed no-padding">
                <a
                  class="style-link body_type"
                  data-filter-type="body"
                  data-param="Coupe&amp;body_type_all[]=Convertible"
                  @click="toggleActive"
                  ><div class="cell-center">
                    <img
                      class="center-block img-responsive"
                      src="../../static/images/common-icons/shop-by-coupe.png"
                      alt="Coupes"/>
                      <small class="center-block text-center"
                      >Coupes/Convertibles</small
                    >
                  </div></a
                >
              </div>
              <div class="col-md-4 col-xs-6 dashed no-padding">
                <a
                  class="style-link body_type"
                  data-filter-type="body"
                  data-param="SUV"
                  @click="toggleActive"
                  ><div class="cell-center">
                    <img
                      class="center-block img-responsive"
                      src="../../static/images/common-icons/shop-by-suv.png"
                      alt="SUVs"/>
                    <small class="center-block text-center"
                      >SUVs/Crossovers</small
                    >
                  </div></a
                >
              </div>
              <div class="col-md-4 col-xs-6 dashed no-padding">
                <a
                  class="style-link body_type"
                  data-filter-type="body"
                  data-param="Minivan"
                  @click="toggleActive"
                  ><div class="cell-center">
                    <img
                      class="center-block img-responsive"
                      src="../../static/images/common-icons/shop-by-minivan.png"
                      alt="Minivans"/>
                    <small class="center-block text-center">Minivans</small>
                  </div></a
                >
              </div>
              <div class="col-md-4 col-xs-6 dashed no-padding">
                <a
                  class="style-link body_type"
                  data-filter-type="query"
                  data-param="Hybrid"
                  @click="toggleActive"
                  ><div class="cell-center">
                    <img
                      class="center-block img-responsive"
                      src="../../static/images/common-icons/shop-by-electric.png"
                      alt="Electric/Hybrid"/>
                    <small class="center-block text-center"
                      >Hybrid/Electric</small
                    >
                  </div></a
                >
              </div>
              <div class="col-md-4 col-xs-6 dashed no-padding">
                <a
                  class="style-link body_type"
                  data-filter-type="body"
                  data-param="Truck"
                  @click="toggleActive"
                  ><div class="cell-center">
                    <img
                      class="center-block img-responsive"
                      src="../../static/images/common-icons/shop-by-truck.png"
                      alt="Trucks"/>
                    <small class="center-block text-center">Trucks</small>
                  </div></a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <h3 class="text-center">Shop by price</h3>
          <div class="shop-by-body">
            <div class="no-margin row">
              <div class="col-md-4 col-xs-6 dashed no-padding">
                <a
                  class="style-link price-range"
                  data-filter-type="price"
                  data-max="15000"
                  data-min="0"
                  @click="toggleActive"
                  ><div class="cell-center">
                    <h2 class="center-block text-center">&lt; $15K</h2>
                  </div></a
                >
              </div>
              <div class="col-md-4 col-xs-6 dashed no-padding">
                <a
                  class="style-link price-range"
                  data-filter-type="price"
                  data-max="20000"
                  data-min="15000"
                  @click="toggleActive"
                  ><div class="cell-center">
                    <h2 class="center-block text-center">$15K - $20K</h2>
                  </div></a
                >
              </div>
              <div class="col-md-4 col-xs-6 dashed no-padding">
                <a
                  class="style-link price-range"
                  data-filter-type="price"
                  data-max="25000"
                  data-min="20000"
                  @click="toggleActive"
                  ><div class="cell-center">
                    <h2 class="center-block text-center">$20K - $25K</h2>
                  </div></a
                >
              </div>
              <div class="col-md-4 col-xs-6 dashed no-padding">
                <a
                  class="style-link price-range"
                  data-filter-type="price"
                  data-max="30000"
                  data-min="25000"
                  @click="toggleActive"
                  ><div class="cell-center">
                    <h2 class="center-block text-center">$25K - $30K</h2>
                  </div></a
                >
              </div>
              <div class="col-md-4 col-xs-6 dashed no-padding">
                <a
                  class="style-link price-range"
                  data-filter-type="price"
                  data-max="35000"
                  data-min="30000"
                  @click="toggleActive"
                  ><div class="cell-center">
                    <h2 class="center-block text-center">$30K - $35K</h2>
                  </div></a
                >
              </div>
              <div class="col-md-4 col-xs-6 dashed no-padding">
                <a
                  class="style-link price-range"
                  data-filter-type="price"
                  data-max="500000"
                  data-min="35000"
                  @click="toggleActive"
                  ><div class="cell-center">
                    <h2 class="center-block text-center">&gt; $35K</h2>
                  </div></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <a
            class="btn btn-lg inventory-type-button-block track-click filter-btn"
            data-action="Find My Car"
            data-category="Home Page Actions"
            href="#"
          >
            Find My Car</a
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  mounted() {
    $("a.brand-link").removeAttr("href");
  },
  methods: {
    toggleActive: function(event) {
      let target = $(event.target)
      target.toggleClass("clicked");
    }
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
#shop-by-style-filter {
  background: #f5f5f5;
  padding-bottom: 20px;
  font-family: Helvetica, Arial, sans-serif;
}
#shop-by-style-filter .shop-by-body {
  background-color: #fff;
  left: auto;
  right: 0;
  margin-top: 0;
  padding: 0;
  animation-name: expand;
  -webkit-animation-name: expand;
  -ms-animation-name: expand;
  -moz-animation-name: expand;
  animation-duration: 0.1s;
  -webkit-animation-duration: 0.1s;
  -ms-animation-duration: 0.1s;
  -moz-animation-duration: 0.1s;
  animation-timing-function: ease-out;
  -webkit-animation-timing-function: ease-out;
  -ms-animation-timing-function: ease-out;
  -moz-animation-timing-function: ease-out;
  transform-origin: 50% 0;
  -ms-transform-origin: 50% 0;
  -webkit-transform-origin: 50% 0;
  -moz-transform-origin: 50% 0;
}
#shop-by-style-filter .shop-by-body.negative .style-link.body_type:hover {
  background-color: #fff;
  opacity: 1;
}
#shop-by-style-filter .shop-by-body.negative .cell-center {
  background-color: #fff;
}
#shop-by-style-filter .shop-by-body.negative .cell-center img {
  background-color: #333;
}
#shop-by-style-filter .shop-by-body.negative .cell-center:hover img, #shop-by-style-filter .shop-by-body.negative .cell-center img.clicked {
  background-color: #3378f5;
}
#shop-by-style-filter .row.no-margin {
  margin-left: 0;
  margin-right: 0;
}
#shop-by-style-filter .dashed {
  border-style: dashed;
  border-color: #ddd;
  border-width: 0 1px 1px 1px;
}
#shop-by-style-filter .style-link {
  display: table;
  width: 100%;
  height: 124px;
  color: #333;
  text-decoration: none;
  opacity: 0.7;
}
#shop-by-style-filter .style-link:hover {
  background-color: #d5d5d5;
  text-decoration: none;
  opacity: 1;
}
#shop-by-style-filter .style-link-active {
  background-color: #d5d5d5;
  opacity: 0.8;
}
#shop-by-style-filter .price-range.style-link:hover h2 {
  color: #000;
}
#shop-by-style-filter .price-range .clicked {
  color: #3378f5 !important;
}
#shop-by-style-filter .cell-center {
  display: table-cell;
  vertical-align: middle;
}
#shop-by-style-filter .price-range h2 {
  font-weight: lighter;
  margin: auto;
  padding: 20px 0;
}
#shop-by-style-filter .btn {
  color: #fff;
  background: var(--primary-color);;
  display: block;
  border-radius: 0;
  font-weight: 500;
  transition: all .2s ease;
  font-size: 18px !important;
}
#shop-by-style-filter[data-brand="cjdr"] .btn {
  background: var(--secondary-color);;
}
#shop-by-style-filter .btn:hover {
  opacity: .7;
}
#shop-by-style-filter a {
  cursor: pointer;
}

@keyframes expand {
  0% {
    transform: scaleY(0.1);
  }
  100% {
    transform: scaleY(1);
  }
}

@-webkit-keyframes expand {
  0% {
    -webkit-transform: scaleY(0.1);
  }
  100% {
    -webkit-transform: scaleY(1);
  }
}

@-ms-keyframes expand {
   0% {
    -ms-transform: scaleY(0.1);
  }
   80% {
    -ms-transform: scaleY(1.01);
  }
   100% {
    -ms-transform: scaleY(1);
  }
}

@-moz-keyframes expand {
  0% {
    -moz-transform: scaleY(0.1);
  }
  100% {
    -moz-transform: scaleY(1);
  }
}
</style>
